<template>
  <v-container>
    <h1>Meine Wunschliste</h1>

    <div v-if="isLoading" class="text-xs-center">
      <v-progress-circular :size="70" :width="7" color="blue-grey lighten-1" indeterminate></v-progress-circular>
    </div>

    <div v-if="!isLoading">
			<v-alert
				v-model="showError"
				type="error"
				transition="scale-transition"
				origin="center center"
			>{{errorMessage}}</v-alert> <!-- 				dismissible -->


      <!-- <div v-if="showError">{{errorMessage}}</div> -->
      <div v-if="!showError && games.length === 0">
				<p>Die Wunschliste ist (noch) leer.</p>
			</div>

      <div v-if="!showError && games.length > 0">
				<p>Hier sind alle von Dir favorisierten Spiele aufgeführt.</p>
        <v-layout>
          <v-flex>
            <v-card v-for="game in games" v-bind:key="game.id" style="margin-bottom: 16px; max-width: 800px">
              <v-img :src="`https://sonnt.ag/steamgiveaway${game.img}`"></v-img>
              <!-- src="https://cdn.vuetifyjs.com/images/cards/desert.jpg" aspect-ratio="2.75" -->
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">{{game.title}}</h3>
                  <div>
                    <!-- <span v-for="genre in game.genres" v-bind:key="genre" style="margin-right: 8px">{{genre}}</span> -->
										<v-breadcrumbs :items="game.genres"></v-breadcrumbs>
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
								<v-layout row wrap>
									<v-btn flat color="info" v-on:click="openSteampage(game)">Öffne Steampage</v-btn>
									<v-btn v-bind:loading="!!game.isLoadingWishlist" flat color="error" v-on:click="removeFromWishlist(game)">Von Wunschliste entfernen</v-btn>
									<v-btn v-if="!game.id_redemption" flat color="success" v-on:click="redeem(game, true)">Jetzt Freischalten</v-btn>
									<v-btn v-if="game.id_redemption" flat disabled>Leider schon vergeben</v-btn>
								</v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <v-snackbar
      v-model="showSnackbar"
      bottom
      v-bind:timeout="6000"
			v-bind:color="snackbarColor"
    >
      {{ snackbarText }}
      <v-btn
        flat
        @click="showSnackbar = false"
      >
        Schließen
      </v-btn>
    </v-snackbar>

    <v-dialog
      v-if="redemption.game"
			v-model="redemption.showDialog"
      width="800"
    >
      <v-card>
        <v-card-title
          class="headline blue-grey lighten-1"
          primary-title
        >
          {{redemption.game.title}} Freischalten
        </v-card-title>

        <v-card-text v-if="!redemption.isSuccess">
          Möchtest Du wirklich {{redemption.game.title}} für Dich freischalten?
        </v-card-text>

				<v-card-text v-if="redemption.isSuccess">
					<p>Steam Key: {{redemption.key}} <v-btn color="success" flat v-on:click="redeemOnSteam">Bei Steam einlösen</v-btn> </p>
					<p v-if="redemption.keynote">Anmerkungen: {{redemption.keynote}}</p>
					<p>Deine freigeschalteten Spiele kannst Du auch später noch unter <a href="/#/mygames">Meine Spiele</a> einsehen.</p>
				</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
					<v-layout row wrap>
						<v-spacer></v-spacer>
						<v-btn
							v-if="!redemption.isSuccess"
							color="error"
							flat
							v-on:click="redemption.showDialog = false"
						>
							Nö, doch lieber nicht
						</v-btn>
						<v-btn
							v-if="!redemption.isSuccess"
							color="success"
							flat
							v-on:click="redeem(redemption.game, false)"
							v-bind:loading="redemption.isLoading"
						>
							Ja, Unbedingt!
						</v-btn>
						<v-btn
							v-if="redemption.isSuccess"
							color=""
							flat
							v-on:click="redemption.showDialog = false"
						>
							Schließen
						</v-btn>
					</v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>		
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";

import { eventBus } from '../main'; 

export default {
  data: () => ({
    username: null,

    games: [],

    isLoading: false,
    showError: false,
		errorMessage: "",

		showSnackbar: false,
		snackbarText: '',
		snackbarColor: '',

		redemption: {
			showDialog: false,
			game: null,
			isLoading: false,
			isSuccess: false,
			key: '',
			keynote: '',
			steamurl: '',
		}
  }),

  methods: {
    loadGames() {
      this.isLoading = true;
      this.showError = false;
			this.errorMessage = "";

      const url = process.env.VUE_APP_APIBASEURL + "/wishlist";
      console.log("fetching /wishlist:", url);
      axios
        .get(url, { headers: { user: this.username } })
        .finally(() => {
          this.isLoading = false;
        })
        .then(response => {
          const games = response.data;
          games.forEach(game => {
            game.genres = JSON.parse(game.genres).map(genre => {
							return {
								text: genre,
								disabled: true
							}
						});
          });
          this.games = response.data;
        })
        .catch(error => {
					this.showError = true;

          this.errorMessage = error.message;

          if (error.response && error.response.data && error.response.data.error) {
            this.errorMessage = error.response.data.error;
					}
					
					this.errorMessage = 'Beim Abruf der Daten trat ein Fehler auf, bitte versuche es später noch einmal. Der Fehler war: ' + this.errorMessage;

          return;
        });
    },

		loadLastRedemption() {
      const url = process.env.VUE_APP_APIBASEURL + "/lastredemption";
      console.log("fetching /lastredemption:", url);
      axios
        .get(url, { headers: { user: this.username } })
        .then(response => {
					let lastRedemption = null;
					
					console.log(response.data);
					
					if (response.data && response.data.lastredemption) {
						lastRedemption = moment(response.data.lastredemption);
						console.log('last redemption is:', lastRedemption);
					} else {
						console.log('last redemption is not set (we provide null)');
					};

					eventBus.setLastRedemption(lastRedemption);
				})
        .catch(error => {
					console.log('fetch /lastredemption ERROR:', error);
          return;
				});
		},

		openSteampage(game) {
      const win = window.open(game.url, "_blank");
      win.focus();
    },

		removeFromWishlist(game) {
			game.isLoadingWishlist = true;

			const options = {
					method: 'POST',
					url: process.env.VUE_APP_APIBASEURL + '/removefromwishlist?wishlistid=' + game.wishlistid,
					data: null,
					headers: {
						user: this.username
					},
					json: false
			};

      console.log("removing from wishlist:", options);
      axios(options)
        //.post(url, { headers: { user: this.username } })
        .finally(() => {
          game.isLoadingWishlist = false;
        })
        .then(response => {
					console.log('RESPONSE!');
					this.snackbarColor = '';
					this.showSnackbar = true;
					this.snackbarText = 'Spiel wurde von Wunschliste entfernt.';
					this.loadGames();
        })
        .catch(error => {
					console.log('ERROR!');
					this.snackbarColor = 'error';
					this.showSnackbar = true;

          this.snackbarText = error.message;

          if (error.response && error.response.data && error.response.data.error) {
            this.snackbarText = error.response.data.error;
					}
					
					this.snackbarText = this.snackbarText;

          return;
        });
		},

    redeem(game, prepare) {
			if (prepare) {
				// just the redemption start - init some vars and show dialog
				this.redemption.game = game;
				this.redemption.showDialog = true;
				this.redemption.isLoading = false;

				this.redemption.isSuccess = false;
				this.redemption.key = '';
				this.redemption.keynote = '';
				this.redemption.steamurl = '';

				return;
			}

			this.redemption.isLoading = true;

			const options = {
					method: 'POST',
					url: process.env.VUE_APP_APIBASEURL + '/redeem?gameid=' + game.id,
					data: null,
					headers: {
						user: this.username
					},
					json: false
			};

      console.log("redeeming:", options);
      axios(options)
        //.post(url, { headers: { user: this.username } })
        .finally(() => {
          this.redemption.isLoading = false;
        })
        .then(response => {
					console.log('RESPONSE!', response);
					this.redemption.isSuccess = true;
					this.redemption.key = response.data.key;
					this.redemption.keynote = response.data.keynote;
					this.redemption.steamurl = 'https://store.steampowered.com/account/registerkey?key=' + response.data.key;
				})
        .catch(error => {
					console.log('ERROR!');
					this.snackbarColor = 'error';
					this.showSnackbar = true;

          this.snackbarText = error.message;

          if (error.response && error.response.data && error.response.data.error) {
            this.snackbarText = error.response.data.error;
					}
					
					this.snackbarText = this.snackbarText;

          return;
        });
		},

		redeemOnSteam() {
      const win = window.open(this.redemption.steamurl, "_blank");
      win.focus();
		},
  },

  // ### Life-Cycle Hooks ###
  created() {
    console.log("AllGames.vue CREATED!");

    this.username = localStorage.getItem("u");

    if (!this.username) {
      console.log("username not found, redirecting to /login");
      this.$router.push("/login");
      return;
    }

		this.loadGames();
		this.loadLastRedemption();
  }
};
</script>

<style>
</style>
